// @flow
import { ActionHelper } from 'modules/helper';

const actionTypePrefix = 'About/';
export const AboutActionTypes = {
  NEWS: ActionHelper.createActionTypes(actionTypePrefix, 'NEWS'),
};
